module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_chloroplast_photosynthesis_4-413d2097b3275599d9c837f9eed74fad.jpg";